interface Props {
    count: number;
    title: string;
  }
  
  const LeadCountCard: React.FC<Props> = ({ count, title }) => {
    return (
      <div className="count-card">
        <h2>{count}</h2>
        <p>{title}</p>
      </div>
    );
  };
  
  export default LeadCountCard;
  